var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_2",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37820",
    "data-name": "Group 37820",
    transform: "translate(-1067 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1067, 32)",
    filter: "url(#Ellipse_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    "data-name": "Ellipse 2",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(1087.792 50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "settings",
    d: "M22.2,14.4,21,13.7a2.058,2.058,0,0,1,0-3.5l1.2-.7a1.9,1.9,0,0,0,.7-2.7l-1-1.7a1.9,1.9,0,0,0-2.7-.7L18,5.1a2,2,0,0,1-3-1.7V2a2.006,2.006,0,0,0-2-2H11A2.006,2.006,0,0,0,9,2V3.3A2,2,0,0,1,6,5L4.8,4.4a1.939,1.939,0,0,0-2.7.7l-1,1.7a2.181,2.181,0,0,0,.7,2.8l1.2.7a1.97,1.97,0,0,1,0,3.4l-1.2.7a1.9,1.9,0,0,0-.7,2.7l1,1.7a1.9,1.9,0,0,0,2.7.7L6,18.9a2,2,0,0,1,3,1.7V22a2.006,2.006,0,0,0,2,2h2a2.006,2.006,0,0,0,2-2V20.7A2,2,0,0,1,18,19l1.2.7a1.939,1.939,0,0,0,2.7-.7l1-1.7A2.282,2.282,0,0,0,22.2,14.4ZM12,16a4,4,0,1,1,4-4A4.012,4.012,0,0,1,12,16Z",
    fill: "#2580ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.9fc7ca7a02536975515abf683c738af0.svg";
export { ForwardRef as ReactComponent };